import {EventEmitter, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {isNullOrUndefined} from '../shared/is-null-or-undefined';
import {TranslationService} from './translation.service';

@Injectable()
// this DataService class will handle all data used in the application provided by the RestService for easy

// access
export class DataService {
    dataChangedCars: EventEmitter<any> = new EventEmitter();
    dataChangedOverview: EventEmitter<any> = new EventEmitter();
    dataChangedOnlineCars: EventEmitter<any> = new EventEmitter();
    dataChangedSession: EventEmitter<any> = new EventEmitter();
    dataChangedCarsOnMap: EventEmitter<any> = new EventEmitter();

    userInfo: any;
    sessionIdentifier: any;
    overviewData: any;
    onlineCars: any;
    cars: Array<any>;
    currentCarsOnMap: any;

    constructor(
        private router: Router,
        private translationService: TranslationService
    ) { /* noop */
    }

    getSessionIdentifier() {
        return this.sessionIdentifier;
    }

    getUserInfo() {
        return this.userInfo;
    }

    setUserInfo(info: any) {
        this.userInfo = info;
        this.sessionIdentifier = this.userInfo.SessionIdentifier;
        this.translationService.setLanguage(this.userInfo.Language);

        this.dataChangedSession.emit(true);
    }

    getOverviewData() {
        return this.overviewData;
    }

    getCars() {
        return this.cars;
    }

    setOverviewData(newOverviewData: any) {
        this.overviewData = newOverviewData;
        this.dataChangedOverview.emit(true);
    }

    getOnlineCars() {
        return this.onlineCars;
    }

    setOnlineCars(newOnlineCars: any) {
        this.onlineCars = newOnlineCars;
        this.dataChangedOnlineCars.emit(true);
    }

    setCars(newCars: Array<any>) {
        this.cars = newCars;
        this.dataChangedCars.emit(true);
    }

    getCurrentCarsOnMap() {
        return this.currentCarsOnMap;
    }

    setCurrentCarsOnMap(newCarsOnMap: any) {
        this.currentCarsOnMap = newCarsOnMap;
        this.dataChangedCarsOnMap.emit(true);
    }

    isResponseSuccessful(res: any) {
        if (!isNullOrUndefined(res)) {
            if (res.StatusCode === 0) {
                return true;
            }
        }
        return false;
    }


}
